// Modules
import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'

// Aplication
import navIllustration from 'assets/nav-illustration.svg'
import { useAnalytics, useLoginHook } from 'hooks'

// Components
import { TemplateContainerFullWidth } from 'components'
import { Content } from './styles'

interface LocationState {
    analytics: {
        event: string
        path: string
        steps: string
    }
}

export const RegisterExamesActivateCipOrphan: React.FC = () => {
    const history = useHistory()
    const location = useLocation<LocationState>()
    const { authState } = useLoginHook()
    const { state } = location
    const shouldRedirect = !authState.signed

    useAnalytics(state.analytics, !shouldRedirect)

    // verificar qual deve ser o evento correto nessa etapa.
    // const { trackEvent } = useAnalytics(analyticsStep, !shouldRedirect)

    // useEffect(() => {
    //     trackEvent({ ...Analytics.ActivateAccountCipOrphan.ActivateAccountComplete, userId: authState.user?.id })

    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [])

    const handleNext = () => {
        history.push('/exames/laboratorios', { patientId: authState.user?.id })
    }

    if (shouldRedirect) {
        history.push('/login')
        return null
    }

    return (
        <TemplateContainerFullWidth
            buttonText="Cadastrar exames"
            goTo={handleNext}
            image={navIllustration}
            imageAlt="Ilustração de saudação"
            title="Olá, sou Nav Dasa"
            titleType="medium"
        >
            <Content>
                <p>
                    Agora você pode contar comigo para cuidar e acompanhar a sua saúde. Adicione seus exames à sua nova conta para
                    continuar.
                </p>
            </Content>
        </TemplateContainerFullWidth>
    )
}
